if (!customElements.get('cart-drawer-cross-sell')) {
  customElements.define(
    'cart-drawer-cross-sell',
    class CartDrawerCrossSell extends HTMLElement {
      static colorMap = {
        'true black': '#111111',
        black: '#111111',
        cement: '#c8c8c4',
        plasma: '#e31c23',
        primer: '#e6d3b3',
        future: '#5b4d9a',
        white: '#f3f3f3',
        'bone white': '#efe6d9',
        moab: '#c45c26',
        olive: '#6b6b3a',
        sage: '#9aa58a',
        navy: '#1c2b4a',
        red: '#d61f26',
        blue: '#2f6fed',
        gray: '#9a9a9a',
        grey: '#9a9a9a',
      };

      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.products = this.readJson('[data-xsell-products]') || [];
        this.productId = '';
        this.variantId = '';
        this.productTrigger = this.querySelector('[data-xsell-product-trigger]');
        this.colorTrigger = this.querySelector('[data-xsell-color-trigger]');
        this.productLabel = this.querySelector('[data-xsell-product-label]');
        this.colorLabel = this.querySelector('[data-xsell-color-label]');
        this.productMenu = this.querySelector('[data-xsell-product-menu]');
        this.colorMenu = this.querySelector('[data-xsell-color-menu]');
        this.productDropdown = this.querySelector('[data-xsell-dropdown="product"]');
        this.colorDropdown = this.querySelector('[data-xsell-dropdown="color"]');
        this.addButton = this.querySelector('[data-xsell-add]');
        this.priceCopy = this.querySelector('[data-xsell-price-copy]');
        this.priceEl = this.querySelector('[data-xsell-price]');
        this.compareEl = this.querySelector('[data-xsell-compare]');
        this.badgeEl = this.querySelector('[data-xsell-badge]');
        this.discountPercent = Number(this.dataset.discountPercent || 0);
        this.portal = this.closest('.drawer__inner');
        if (!this.productTrigger || !this.colorTrigger || !this.addButton) return;

        if (this.products.length && this.productMenu && !this.productMenu.children.length) {
          this.renderSpeakers();
        }
        this.bindSpeakerButtons();
        this.productTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleMenu('product');
        });
        this.colorTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.colorTrigger.disabled) return;
          this.toggleMenu('color');
        });
        this.addButton.addEventListener('click', () => this.addToCart());
        this.onDocClick = (event) => {
          if (this.ignoreDocClick) return;
          if (this.contains(event.target)) return;
          if (this.productMenu?.contains(event.target)) return;
          if (this.colorMenu?.contains(event.target)) return;
          this.closeMenus();
        };
        this.onKey = (event) => {
          if (event.key === 'Escape') this.closeMenus();
        };
        this.onScroll = () => this.closeMenus();
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
        this.scrollRoot = this.closest('.cart-drawer__scroll');
        this.scrollRoot?.addEventListener('scroll', this.onScroll, { passive: true });
        this.sync();
      }

      disconnectedCallback() {
        this.closeMenus();
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        this.scrollRoot?.removeEventListener('scroll', this.onScroll);
        this.bound = false;
      }

      readJson(selector) {
        const script = this.querySelector(selector);
        if (!script) return [];
        try {
          const parsed = JSON.parse(script.textContent.trim());
          return Array.isArray(parsed) ? parsed.filter((product) => product && product.id) : [];
        } catch (error) {
          return [];
        }
      }

      selectedProduct() {
        return this.products.find((product) => String(product.id) === String(this.productId)) || null;
      }

      selectedVariant() {
        const product = this.selectedProduct();
        if (!product) return null;
        return product.variants.find((variant) => String(variant.id) === String(this.variantId)) || null;
      }

      colorLabelFor(product, variant) {
        return variant.color || (variant.options && variant.options[product.colorOptionIndex || 0]) || variant.title;
      }

      uniqueColors(product) {
        const seen = new Set();
        return (product.variants || []).filter((variant) => {
          const label = this.colorLabelFor(product, variant);
          if (seen.has(label)) return false;
          seen.add(label);
          return true;
        });
      }

      swatchStyle(variant, product) {
        const label = this.colorLabelFor(product || {}, variant);
        const mapped = CartDrawerCrossSell.colorMap[String(label || '').trim().toLowerCase()];
        if (mapped) return `background-color:${mapped}`;
        if (variant.image) {
          return `background-image:url(${variant.image});background-size:cover;background-position:center`;
        }
        return 'background-color:#d0d0d0';
      }

      renderSpeakers() {
        this.productMenu.innerHTML = this.products
          .map((product) => {
            const image = product.image
              ? `<img class="cart-drawer-xsell__option-img" src="${product.image}" alt="" width="28" height="28">`
              : `<span class="cart-drawer-xsell__option-img"></span>`;
            return `<li>
              <button type="button" class="cart-drawer-xsell__option" role="option" data-product-id="${product.id}">
                ${image}
                <span>${this.escape(product.title)}</span>
              </button>
            </li>`;
          })
          .join('');
      }

      bindSpeakerButtons() {
        this.productMenu.querySelectorAll('[data-product-id]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.selectProduct(button.getAttribute('data-product-id'));
          });
        });
      }

      renderColors() {
        const product = this.selectedProduct();
        this.colorMenu.innerHTML = '';
        if (!product) return;
        this.uniqueColors(product).forEach((variant) => {
          const label = this.colorLabelFor(product, variant);
          const item = document.createElement('li');
          item.innerHTML = `<button type="button" class="cart-drawer-xsell__option" role="option" data-variant-id="${variant.id}">
            <span class="cart-drawer-xsell__swatch" style="${this.swatchStyle(variant, product)}"></span>
            <span>${this.escape(label)}</span>
          </button>`;
          item.querySelector('button').addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.selectVariant(variant.id);
          });
          this.colorMenu.appendChild(item);
        });
      }

      selectProduct(id) {
        this.productId = String(id);
        this.variantId = '';
        const product = this.selectedProduct();
        this.productLabel.textContent = product ? product.title : 'Select Speaker';
        this.colorTrigger.disabled = !product;
        this.colorLabel.textContent = 'Select Color';
        this.renderColors();
        const colors = product ? this.uniqueColors(product) : [];
        if (colors.length === 1) this.selectVariant(colors[0].id);
        this.closeMenus();
        this.sync();
      }

      selectVariant(id) {
        this.variantId = String(id);
        const product = this.selectedProduct();
        const variant = this.selectedVariant();
        this.colorLabel.textContent = variant ? this.colorLabelFor(product, variant) : 'Select Color';
        this.closeMenus();
        this.sync();
      }

      toggleMenu(which) {
        const menu = which === 'product' ? this.productMenu : this.colorMenu;
        const trigger = which === 'product' ? this.productTrigger : this.colorTrigger;
        const home = which === 'product' ? this.productDropdown : this.colorDropdown;
        const isOpen = !menu.hidden && trigger.classList.contains('is-open');
        document.querySelectorAll('cart-drawer-cross-sell').forEach((el) => {
          if (el !== this && typeof el.closeMenus === 'function') el.closeMenus();
        });
        this.closeMenus();
        if (isOpen || !menu) return;
        this.ignoreDocClick = true;
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        trigger.classList.add('is-open');
        this.placeMenu(menu, trigger, home);
        requestAnimationFrame(() => {
          this.ignoreDocClick = false;
        });
      }

      placeMenu(menu, trigger, home) {
        const portal = this.portal;
        if (!portal) {
          home?.appendChild(menu);
          return;
        }

        const portalRect = portal.getBoundingClientRect();
        const triggerRect = trigger.getBoundingClientRect();
        portal.appendChild(menu);
        menu.style.position = 'absolute';
        menu.style.left = `${triggerRect.left - portalRect.left}px`;
        menu.style.top = `${triggerRect.bottom - portalRect.top + 4}px`;
        menu.style.minWidth = `${Math.max(triggerRect.width, 160)}px`;
        menu.style.width = 'max-content';
        menu.style.maxWidth = '24rem';
        menu.style.zIndex = '30';
        menu.hidden = false;

        requestAnimationFrame(() => {
          const box = menu.getBoundingClientRect();
          const latestPortal = portal.getBoundingClientRect();
          if (box.bottom > latestPortal.bottom - 8) {
            menu.style.top = `${triggerRect.top - latestPortal.top - box.height - 4}px`;
          }
          if (box.right > latestPortal.right - 8) {
            menu.style.left = `${Math.max(8, latestPortal.width - box.width - 8)}px`;
          }
        });
      }

      restoreMenu(menu, home) {
        if (!menu) return;
        menu.hidden = true;
        menu.style.cssText = '';
        if (home && menu.parentElement !== home) home.appendChild(menu);
      }

      closeMenus() {
        this.restoreMenu(this.productMenu, this.productDropdown);
        this.restoreMenu(this.colorMenu, this.colorDropdown);
        [this.productTrigger, this.colorTrigger].forEach((trigger) => {
          if (!trigger) return;
          trigger.setAttribute('aria-expanded', 'false');
          trigger.classList.remove('is-open');
        });
      }

      formatMoney(cents) {
        const value = (Number(cents) / 100).toFixed(2);
        const format = this.dataset.moneyFormat || '${{amount}}';
        return format
          .replace(/\{\{\s*amount\s*\}\}/g, value)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
      }

      discountedPrice(cents) {
        if (!this.discountPercent) return Number(cents);
        const price = Number(cents);
        return price - Math.floor((price * this.discountPercent) / 100);
      }

      setBadge(percent) {
        if (!this.badgeEl) return;
        if (percent > 0) {
          this.badgeEl.hidden = false;
          this.badgeEl.textContent = `Save ${percent}%`;
        } else {
          this.badgeEl.hidden = true;
          this.badgeEl.textContent = '';
        }
      }

      setCompare(cents) {
        if (!this.compareEl) return;
        if (cents > 0) {
          this.compareEl.textContent = this.formatMoney(cents);
          this.compareEl.classList.add('is-set');
        } else {
          this.compareEl.textContent = '$XX.XX';
          this.compareEl.classList.remove('is-set');
        }
      }

      sync() {
        const variant = this.selectedVariant();
        this.classList.toggle('is-selected', Boolean(this.productId));
        this.classList.toggle('is-priced', Boolean(variant));
        this.productMenu?.querySelectorAll('[data-product-id]').forEach((button) => {
          button.classList.toggle('is-active', button.getAttribute('data-product-id') === String(this.productId));
        });
        this.colorMenu?.querySelectorAll('[data-variant-id]').forEach((button) => {
          button.classList.toggle('is-active', button.getAttribute('data-variant-id') === String(this.variantId));
        });

        if (variant) {
          const price = Number(variant.price);
          const compareAt = Number(variant.compareAtPrice || 0);
          let sale = price;
          let compare = 0;
          let percent = 0;

          if (compareAt > price) {
            sale = price;
            compare = compareAt;
            percent = Math.round(((compareAt - price) / compareAt) * 100);
          } else if (this.discountPercent > 0) {
            sale = this.discountedPrice(price);
            compare = price;
            percent = this.discountPercent;
          }

          this.priceEl.textContent = this.formatMoney(sale);
          this.setCompare(compare > sale ? compare : 0);
          this.setBadge(percent);
          this.addButton.disabled = false;
        } else {
          this.priceEl.textContent = '$XX.XX';
          this.setCompare(0);
          this.setBadge(this.discountPercent);
          this.addButton.disabled = true;
        }
      }

      escape(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      addToCart() {
        const variant = this.selectedVariant();
        const drawerV2 = document.querySelector('cart-drawer-v2');
        const cartDrawer = document.querySelector('cart-drawer');
        if (!variant || this.addButton.disabled) return;

        this.addButton.disabled = true;
        this.addButton.classList.add('loading');
        const spinner = this.addButton.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const sections = drawerV2
          ? ['cart-drawer-v2', 'cart-icon-bubble']
          : cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender().map((section) => section.id)
            : ['cart-drawer', 'cart-icon-bubble'];

        const body = {
          items: [
            {
              id: Number(variant.id),
              quantity: 1,
              properties: {
                _bundle_save: 'true',
                _CrossSell: 'true',
                _xsell_source: this.dataset.sourceTitle || '',
              },
            },
          ],
          sections,
          sections_url: window.location.pathname,
        };

        const finish = () => {
          this.addButton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          this.addButton.disabled = !this.selectedVariant();
        };

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) return null;
            return fetch(`${routes.cart_update_url}`, {
              ...fetchConfig('javascript'),
              body: JSON.stringify({
                attributes: { CrossSell: 'true' },
                sections,
                sections_url: window.location.pathname,
              }),
            }).then((response) => response.json());
          })
          .then((state) => {
            if (!state || state.status) return;
            if (drawerV2 && typeof drawerV2.refreshAndOpen === 'function') {
              drawerV2.classList.remove('is-empty');
              return drawerV2.refreshAndOpen();
            }
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(state);
            }
          })
          .catch(() => {})
          .finally(finish);
      }
    }
  );
}
